var CustomerInformationInputType;
(function (CustomerInformationInputType) {
    CustomerInformationInputType[CustomerInformationInputType["AUTOMATIC"] = 0] = "AUTOMATIC";
    CustomerInformationInputType[CustomerInformationInputType["MANUAL"] = 1] = "MANUAL";
})(CustomerInformationInputType || (CustomerInformationInputType = {}));
export default CustomerInformationInputType;
